import { useMemo } from 'react';
import { useRequests } from '../redux/reducer/requests';

/**
 * Хук для проверки включения/выключения фичи
 * @param {string} featureName - Название фичи
 * @returns {boolean} - true, если фича включена, false - если выключена
 */
export const useFeatureToggle = (featureName) => {
  const {
    authData: { featureToggles },
  } = useRequests();

  return useMemo(() => Boolean(featureToggles && featureToggles[featureName] === true), [featureToggles, featureName]);
};
